import { QueryClient } from '@tanstack/react-query'
import Keycloak from 'keycloak-js'

export const getKcToken = async (kc?: Keycloak) => {
  const expired = kc?.isTokenExpired(0)
  if (expired) {
    try {
      await kc?.updateToken(5)
    } catch {
      await kc?.login()
    }
  }
  return `Bearer ${kc?.token}`
}

export const initQueryClient = () => {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1000 * 60 * 5,
        retry: 1,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchOnMount: false
      }
    }
  })
}
